import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Alert } from '@mui/material';
import { certApi } from '../../api/certApi';

interface Props {
    token: string;
    serial: string;
    cn: string;
    onRevoked: () => void;
}

const RevokeButton: React.FC<Props> = ({ token, serial, cn, onRevoked }) => {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [error, setError] = useState<string | undefined>();
    const [submitting, setSubmitting] = useState(false);

    const submit = async () => {
        setError(undefined);
        setSubmitting(true);
        try {
            await certApi.revoke(token, serial, reason || undefined);
            setOpen(false);
            onRevoked();
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Button size='small' color='warning' onClick={() => setOpen(true)}>Revoke</Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='xs'>
                <DialogTitle>Revoke {cn}?</DialogTitle>
                <DialogContent>
                    {error && <Alert severity='error' sx={{ mb: 2 }}>{error}</Alert>}
                    <TextField label='Reason (optional)' fullWidth value={reason} onChange={e => setReason(e.target.value)} sx={{ mt: 1 }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={submitting}>Cancel</Button>
                    <Button color='error' variant='contained' onClick={submit} disabled={submitting}>
                        {submitting ? 'Revoking...' : 'Revoke'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default RevokeButton;
